module.exports = __webpack_public_path__ + "img/instagram.b652d19a.svg";